import { Injectable } from '@angular/core';
import { AppConfig } from '../model/config';
import { HttpHelper } from './http.service';

@Injectable()
export class UserImportService {

  constructor(
    private readonly httpClient: HttpHelper,
    private readonly configuration: AppConfig) {
  }


  // importworkshift
  async importWorkshiftForDate(date: Date) {

    console.log("importWorkshiftForDate");

    let url: string = this.configuration.backendUrl + "/api/userimport/import";

    return await this.httpClient.post(url, {"date": date}, () => { },
      () => { }).toPromise<any>();
  }
}
